module.exports = __webpack_public_path__ + "static/img/AnnouncementBackdrop.dea7a88a.png";